import api, { METHODS } from './api'

export default async function getOneEmailForRecipientGroupFlag(): Promise<boolean> {
    try {
        const oneEmailForRecipientGroupFlag = await api<{oneEmailForRecipientGroupFlag: boolean}>(
            `oneEmailForRecipientGroupFlag`, // for apache servers
            METHODS.GET
        )

        return oneEmailForRecipientGroupFlag.oneEmailForRecipientGroupFlag
    } catch (error) {
        // TODO: use logger
        // console.error(error)
        console.error("Could not get the current set flag to send one email for recipient group in reports-maker", error)
        
        return false
    }
}